import moment from 'moment';

export default {

    /**
     * Converts a UTC date string to an object with a timestamp in local time and a formatted date string.
     * If the input string is falsy (e.g., null, undefined, or an empty string), the function returns undefined.
     *
     * @param {string} utcDateString - A date string in UTC format (e.g., '2019-06-28T01:00:00Z').
     * @returns { { date: number, dateString: string } | undefined } An object containing:
     *  - 'date': The timestamp in local time (milliseconds since January 1, 1970).
     *  - 'dateString': The formatted date string in local time (e.g., 'Friday, Aug 23, 2024 8:00 PM -05:00').
     *  If the input is falsy, returns undefined.
     */
    convertUTCToLocal(utcDateString) {
        if (!utcDateString) { return; }
        const localMoment = moment.utc(utcDateString).local();
        const timestamp = localMoment.valueOf();
        const dateString = localMoment.format('dddd, MMM D, YYYY h:mm A Z');
        return {
            date: timestamp,
            dateString
        };
    }

};
